module.exports = __webpack_public_path__ + "img/162.aa36ab97.jpg";